import React from "react";
import { Eye, Lock } from "lucide-react";
import { Badge } from "./ui/badge";

/**
 * Phase 152 — small UI helpers for feature-level access.
 *
 *  <ReadOnlyNotice what="Zones" />      compact banner shown when the viewer has "View only" on a feature
 *  <NoAccessPanel what="Import Payments" />  friendly panel when a tab/section is hidden by access rules
 *  <ViewOnlyBadge />                     tiny badge for tab labels / headers
 */
export const ReadOnlyNotice = ({ what, testId = "readonly-notice", className = "" }) => (
  <div className={`flex items-center gap-2 rounded-md border border-sky-200 bg-sky-50/70 text-sky-800 px-3 py-2 text-xs ${className}`}
    role="status" data-testid={testId}>
    <Eye className="h-3.5 w-3.5 shrink-0" />
    <span>
      <span className="font-medium">View only</span> — you can see {what ? <>{what.toLowerCase()}</> : "this section"} but not add, change or
      delete anything. Ask your administrator for full access if you need to make changes.
    </span>
  </div>
);

export const NoAccessPanel = ({ what, testId = "no-access-panel" }) => (
  <div className="rounded-lg border bg-muted/30 p-8 text-center" data-testid={testId}>
    <Lock className="h-7 w-7 mx-auto text-muted-foreground/70" />
    <p className="text-sm font-medium mt-2">{what ? `${what} is not available for your account` : "This section is not available for your account"}</p>
    <p className="text-xs text-muted-foreground mt-1">Access to this feature has been disabled by your administrator.</p>
  </div>
);

export const ViewOnlyBadge = ({ testId }) => (
  <Badge variant="outline" className="text-[10px] ml-1.5 bg-sky-50 text-sky-700 border-sky-200" data-testid={testId}>
    <Eye className="h-2.5 w-2.5 mr-1" /> View only
  </Badge>
);
